import React from 'react';
import { capitalize, get } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { Button, InfoLabel } from '../../../../../../common/components';
import { InternalButtonBar } from '../../../../../layout/components';

const NOT_APPLICABLE = 'not applicable';
const NOT_USER = 'No Account';

const CustomerStatus = ({ customerStatus }) => {
  if (customerStatus !== NOT_APPLICABLE) {
    return (
      <InfoLabel
        label="Account status"
        value={capitalize(customerStatus)}
        labelSize={4}
      />
    );
  }
  return (
    <InfoLabel
      label="Account status"
      value={NOT_USER}
      labelSize={4}
      wrapperClass={'margin-label-fix'}
    />
  );
};

const CreateAccountButton = ({ customerStatus, customerId, handleCreateUser }) => {
  if (customerStatus === NOT_APPLICABLE) {
    return (
      <Button
        label={'Create An Account'}
        bsStyle="primary"
        key={'create-an-account'}
        className=""
        handleClick={() => handleCreateUser(customerId)}
      />
    );
  }
  return null;
};

const CustomerDetails = ({
  customer,
  address,
  communications,
  handleCreateUser,
  productCode,
}) => {
  if (!customer.data.attributes) {
    return (
      <>
        <Row>
          <Col sm={12} className="section-title">
            <h4>Customer Details</h4>
          </Col>
        </Row>
        <div className="hr" />
      </>
    );
  }

  const paProduct = ['HCP', 'SC'];

  const selectedCommunications = communications
    ? Object.keys(communications).filter((communication) => communications[communication])
    : [];
  const customerMarketing = customer.data.attributes?.marketing_options;

  const selectedMarketing = customerMarketing
    ? Object.keys(customerMarketing).filter(
        (marketingOption) => customerMarketing[marketingOption] !== -1,
      )
    : [];

  return (
    <>
      <Row>
        <Col sm={12} className="section-title">
          <h4>Customer Details</h4>
        </Col>
        <Col sm={6}>
          <InfoLabel
            label="Customer name"
            value={customer.data.attributes.customer_name}
            labelSize={4}
          />
          <InfoLabel label="Address" value={address || 'TBA'} labelSize={4} />
        </Col>
        <Col sm={6}>
          <InfoLabel
            isLowerCase
            label="Email"
            value={customer.data.attributes.email || 'TBA'}
            labelSize={4}
          />
          <InfoLabel
            label="Phone"
            value={customer.data.attributes.phone1 || 'TBA'}
            labelSize={4}
          />
          <InfoLabel
            label="Mobile"
            value={customer.data.attributes.phone2 || 'TBA'}
            labelSize={4}
          />
          <CustomerStatus customerStatus={get(customer, 'data.attributes.status')} />
          <InfoLabel
            label="Communications"
            value={selectedCommunications.length ? selectedCommunications.join(', ') : ''}
            labelSize={4}
          />
          {selectedMarketing && selectedMarketing.length > 0 && (
            <InfoLabel
              label="Marketing"
              value={selectedMarketing.join(', ')}
              labelSize={4}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {!paProduct.includes(productCode) && (
            <InternalButtonBar
              buttons={[
                {
                  permissions: ['customer.edit'],
                  button: (
                    <CreateAccountButton
                      customerStatus={get(customer, 'data.attributes.status')}
                      customerId={get(customer, 'data.id')}
                      handleCreateUser={handleCreateUser}
                    />
                  ),
                },
              ]}
            />
          )}
        </Col>
      </Row>
      <div className="hr" />
    </>
  );
};

export default CustomerDetails;
